module.exports = __webpack_public_path__ + "img/logo.9813f17c.png";